import styles from 'css/src/components/common/ui/clickable-hover-overlay.module.scss';

import React from 'react';
import classNames from 'classnames';

type Props = {
    hoverText?: React.ReactNode;
    onClick?: VoidFunction;
    className?: string;
    absolutePositioned?: boolean;
    children?: React.ReactNode;
};

const ClickableHoverOverlay = React.memo(function ClickableHoverOverlay({
    hoverText,
    onClick,
    className,
    absolutePositioned,
    children,
}: Props) {
    /*
    Wrapper component which, when hovering, displays a message at the bottom.  Any clicks prompt
    a callback.
    */
    return (
        <div
            className={classNames(styles['clickable-hover-overlay'], className, {
                [styles['absolute-positioned']]: absolutePositioned,
            })}
            onClick={onClick}
        >
            {children}
            {hoverText ? <div className={styles['hover-message']}>{hoverText}</div> : null}
        </div>
    );
});

export default ClickableHoverOverlay;
